import cn from 'classnames';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import UserImg from '@assets/png/user-1.png';
import InfoCard from '@components/info-card';
import { ReactComponent as UserIcon } from '@assets/svg/user.svg';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { IBlackjackGame } from '@api/types/blackjack';
import styles from './room-games.module.scss';

export interface IRoomGamesItemProps {
  data: IBlackjackGame;
}

const RoomGamesItem = ({
  data: {
    cost,
    players,
    game_metadata: { creator, max_players },
    uid,
  },
}: IRoomGamesItemProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  const hover = (): void => setIsHovered(true);
  const normal = (): void => setIsHovered(false);

  /* Components */

  const PlayersCount: JSX.Element = (
    <>
      <UserIcon />
      <span>
        {players.length}/{max_players}
      </span>
    </>
  );

  const PlayersCountHover: JSX.Element = (
    <span>{players.length >= max_players ? 'Full' : 'Join'}</span>
  );

  /* ClassNames */

  const containerClasses: string = cn(styles.roomGamesItem, {
    [styles.available]: players.length < max_players,
    [styles.full]: players.length >= max_players,
  });

  return (
    <Link
      to={`/games/blackjack/game/${uid}`}
      className={containerClasses}
      onMouseEnter={hover}
      onMouseLeave={normal}
    >
      <div className={styles.playersCount}>
        {isHovered ? PlayersCountHover : PlayersCount}
      </div>
      <div className={styles.body}>
        <InfoCard
          text={cost.toString()}
          icon={<CoinIcon />}
          color="black-gradient"
          className={styles.body__cost}
          center
        />
        <img src={creator ? creator.avatar_url : UserImg} alt="" />
      </div>
      <div className={styles.footer}>
        <p>#{uid}</p>
      </div>
    </Link>
  );
};

export default RoomGamesItem;
